// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__uHB48","showModal":"Modal_showModal__BFqwr","outer":"Modal_outer__nGyvG","close":"Modal_close__NG+n3"};